import { combineReducers } from 'redux'
import data from './dataReducers'

const appReducer = combineReducers({
  data
})

const rootReducer = (state, action) => {
  return appReducer(state, action)
}

export default rootReducer
